module.exports = __webpack_public_path__ + "static/media/Image-Milestones3.7a7b4ed8.png";